import { Link } from "react-router-dom";
import { logos, site } from "@/lib/siteConfig";

// Renders the official AZ logo file exactly as provided (full lockup),
// used as the clickable home link. No recreation/cropping of the artwork.
export const Logo = ({ className = "", testid = "logo-home-link", imgClassName = "h-5 sm:h-8" }) => {
  const returnToHomeTop = () => {
    window.scrollTo({ top: 0, left: 0, behavior: "smooth" });
  };

  return (
    <Link
      to="/"
      onClick={returnToHomeTop}
      data-testid={testid}
      aria-label={`${site.name} – Startseite`}
      className={`inline-flex shrink-0 items-center ${className}`}
    >
      <img
        src={logos.src}
        alt={`${site.name} – ${site.slogan}`}
        className={`${imgClassName} w-auto select-none object-contain`}
        draggable="false"
      />
    </Link>
  );
};
